import { Navigate } from 'react-router-dom';
import AdminDashboard from '../pages/Admin/AdminDashboard';
import Customers from '../pages/Admin/Customers';
import MyProfile from '../pages/Admin/MyProfile';
import AccountSettings from '../pages/Admin/AccountSettings';
import Plans from '../pages/Admin/Plans';

const adminRoutes = [
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />
  },
  {
    path: '/admin/all-customers',
    element: <Customers />
  },
  {
    path: '/admin/plans',
    element: <Plans />
  },
  {
      path: '/admin/my-profile',
      element: <MyProfile/>
    },
    {
      path: '/admin/account-setting',
      element: <AccountSettings/>
    },
  {
    path: '/customer/*',
    element: <Navigate to="/admin/all-customers" replace />
  },
  {
    path: '*',
    element: <Navigate to="/admin/dashboard" />
  }
];

export default adminRoutes;
